(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cl23-card-label"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cl23-card-label')) {
  customElements.define('cl23-card-label', class extends HTMLElement {
    constructor() {
      super();
      this.onOutside = this.onOutside.bind(this);
      this.addEventListener('pointerenter', () => this.expand(true));
      this.addEventListener('pointerleave', () => { if (!this.pinned && !this.contains(document.activeElement)) this.expand(false); });
      this.addEventListener('focusin', () => this.expand(true));
      this.addEventListener('focusout', () => { this.pinned = false; this.expand(false); });
      this.addEventListener('keydown', (event) => { if (event.key === 'Escape') { this.pinned = false; this.expand(false); } });
      this.addEventListener('click', (event) => { if (!event.target.closest('button')) return; event.preventDefault(); event.stopPropagation(); this.pinned = !this.pinned; this.expand(this.pinned); });
    }
    connectedCallback() { document.addEventListener('pointerdown', this.onOutside); this.dataset.ready = 'true'; }
    disconnectedCallback() { document.removeEventListener('pointerdown', this.onOutside); }
    expand(open) { this.dataset.expanded = String(open); this.querySelector('button')?.setAttribute('aria-expanded', String(open)); }
    onOutside(event) { if (!this.contains(event.target)) { this.pinned = false; this.expand(false); } }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cl23-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cl23-size-guide')) {
  customElements.define('cl23-size-guide', class extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onVariant = this.onVariant.bind(this);
      this.onLegacyClick = this.onLegacyClick.bind(this);
      this.onSectionUnload = this.onSectionUnload.bind(this);
    }
    connectedCallback() {
      this.modal = this.closest('modal-dialog');
      if (!this.modal || this.connected) return;
      this.connected = true;
      this.addEventListener('click', this.onClick);
      this.modal.addEventListener('keydown', this.onKeyDown);
      document.addEventListener('product:variant-change', this.onVariant);
      document.addEventListener('click', this.onLegacyClick, true);
      document.addEventListener('shopify:section:unload', this.onSectionUnload);
      this.wasOpen = this.modal.hasAttribute('open');
      this.observer = new MutationObserver(() => {
        const open = this.modal.hasAttribute('open');
        if (this.wasOpen && !open && this.modal.openedBy?.isConnected) this.modal.openedBy.focus({ preventScroll: true });
        this.wasOpen = open;
      });
      this.observer.observe(this.modal, { attributes: true, attributeFilter: ['open'] });
      this.dataset.ready = 'true';
      if (this.modal.parentElement !== document.body) queueMicrotask(() => { if (this.modal.isConnected && this.modal.parentElement !== document.body) document.body.appendChild(this.modal); });
    }
    disconnectedCallback() {
      this.connected = false;
      this.removeEventListener('click', this.onClick);
      this.modal?.removeEventListener('keydown', this.onKeyDown);
      document.removeEventListener('product:variant-change', this.onVariant);
      document.removeEventListener('click', this.onLegacyClick, true);
      document.removeEventListener('shopify:section:unload', this.onSectionUnload);
      this.observer?.disconnect();
    }
    onClick(event) {
      const button = event.target.closest('button[data-unit]');
      if (!button || !this.contains(button)) return;
      const unit = button.dataset.unit;
      this.querySelectorAll('[data-unit]').forEach((el) => el.setAttribute('aria-pressed', String(el === button)));
      this.querySelectorAll('[data-in][data-cm]').forEach((el) => { el.textContent = unit === 'in' ? `${el.dataset.in}″` : el.dataset.cm; });
      this.querySelectorAll('[data-guide-unit-label]').forEach((el) => { el.textContent = `(${unit})`; });
    }
    onVariant(event) {
      if (event.detail?.sectionId !== this.dataset.sectionId) return;
      const variant = event.detail?.variant;
      const value = variant?.options?.[Number(this.dataset.sizeOptionIndex)] || variant?.option1;
      if (!value) return;
      const size = String(value).toUpperCase().replace('2XL', 'XXL').replace('3XL', 'XXXL');
      this.querySelectorAll('tr[data-size]').forEach((row) => row.classList.toggle('is-selected', row.dataset.size === size));
    }
    onLegacyClick(event) {
      const anchor = event.target.closest('a[data-size-guide-url]');
      if (!anchor || !anchor.dataset.sizeGuideUrl.includes('frame.23point5.com/size-guide') || typeof this.modal.show !== 'function') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.modal.show(anchor);
    }
    onKeyDown(event) {
      if (event.key !== 'Tab' || !this.modal.hasAttribute('open')) return;
      const focusable = [...this.modal.querySelectorAll('button:not([disabled]), a[href], [tabindex="0"]')].filter((el) => el.getClientRects().length);
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === this.modal.querySelector('[role="dialog"]'))) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }
    onSectionUnload(event) { if (event.detail?.sectionId === this.dataset.sectionId) this.modal.remove(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
